/**
* 头部菜单
*/
<template>
  <div id='navcon-wrap'>
    <el-menu class="el-menu-demo" mode="horizontal" background-color="#334157" text-color="#fff" active-text-color="#fff">
      <!-- <el-button class="buttonimg">
        <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">
      </el-button> -->
      <el-submenu index="2" class="submenu">
        <!-- <template slot="title">{{user.userRealName}}</template> -->
        <template slot="title">{{ username }}</template>
        <el-menu-item @click="changeIsClick()" index="2-2">Modify Password</el-menu-item>
        <el-menu-item @click="exit()" index="2-3">Log out</el-menu-item>
      </el-submenu>
    </el-menu>
    <el-dialog title="Modify Password" width="30%" :visible.sync="isClick">
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="160px" class="demo-ruleForm">
        <el-form-item label="Password" prop="password">
          <el-input type="password" v-model="ruleForm.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Confirm Password" prop="confirmPassword">
          <el-input type="password" v-model="ruleForm.confirmPassword" autocomplete="off"></el-input>
        </el-form-item>
          <div id='button-wrap'>
            <el-button size="mini" type="primary" :loading="loading" @click="sendModifyPwd('ruleForm')">Submit</el-button>
            <el-button size="mini" @click="resetForm('ruleForm')">Reset</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- <div id='el-form-wrap' v-show="isClick">
      <div id='el-form-content'>


      </div>
    </div> -->
  </div>
</template>
<script>
// 导入请求方法
import { loginout,userPwd } from '../api/userMG'
import { setCookie, getCookie, delCookie } from '../utils/util'
export default {
  name: 'navcon',
  data() {
    var setPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password'));
      } else {
        if (this.ruleForm.confirmPassword !== '') {
          this.$refs.ruleForm.validateField('confirmPassword');
        }
        callback();
      }
    };
    var confirmPwd = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter your password again'));
      } else if (value !== this.ruleForm.password) {
        callback(new Error('The two entered passwords are inconsistent!'));
      } else {
        callback();
      }
    };
    return {
      collapsed: false,
      isClick: false,
      loading: false,
      username: JSON.parse(localStorage.getItem('userdata'))._source.account,
      imgshow: require('../assets/img/show.png'),
      imgsq: require('../assets/img/sq.png'),
      user: {},
      ruleForm: {
                password: '',
                confirmPassword: ''
              },
      rules: {
        password: [
          { validator: setPwd, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: confirmPwd, trigger: 'blur' }
        ]
      }
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    console.log(this.collapsed);
    console.log(this.imgsq);
    console.log(this.imgshow);
    this.user = JSON.parse(localStorage.getItem('userdata'));
  },
  methods: {
    // 显示修改界面
    changeIsClick(){
      this.isClick = !this.isClick
    },
    // 修改密码
    sendModifyPwd(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = !this.loading;
          this.ruleForm._id = this.user._id
          userPwd(this.ruleForm)
            .then(res => {
              if (res.code === 201) {
                //如果请求成功就让他2秒跳转路由
                setTimeout(() => {
                  this.loading = !this.loading;
                  delCookie('user')
                  delCookie('pwd')
                  this.$store.commit('logout', 'false')
                  this.$router.push({ path: '/login' })
                  this.$message({
                    type: 'success',
                    message: 'The password has been changed. Please log in again!'
                  })
                }, 1000)
              } else {
                this.$message.error(res.msg)
                this.logining = false
                return false
              }
            })
            .catch(err => {
              this.loading = !this.loading;
              this.$message.error('Failed to change the password. Please try again later!')
            })

        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 退出登录
    exit() {
      this.$confirm('Log out and decide whether to continue?', 'Prompt', {
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
        .then(() => {
          loginout()
            .then(res => {
              if (res.code === 201) {
                //如果请求成功就让他2秒跳转路由
                setTimeout(() => {
                  this.$store.commit('logout', 'false')
                  this.$router.push({ path: '/login' })
                  this.$message({
                    type: 'success',
                    message: res.msg
                  })
                }, 1000)
              } else {
                this.$message.error(res.msg)
                this.logining = false
                return false
              }
            })
            .catch(err => {
              this.logining = false
              this.$message.error('Failed to exit, please try again later！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Has been cancelled!'
          })
        })
    },
    // 切换显示
    toggle(showtype) {
      this.collapsed = !showtype
      this.$root.Bus.$emit('toggle', true)
    }
  }
}
</script>
<style scoped>
 #el-form-wrap{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0,0,0,.5);
    z-index: 33;
 }
 #el-form-content{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  padding: 6px 30px 60px 30px;;
  border-radius: 10px;
  background-color: #fff;
  z-index: 66;
 }
 #button-wrap{
  position: absolute;
  bottom: 0.2rem;
  right: 2%;
  width: 36%;

 }
.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
}
.submenu {
  float: right;
}
.buttonimg {
  height: 60px;
  background-color: transparent;
  border: none;
}
.showimg {
  width: 26px;
  height: 26px;
  position: absolute;
  top: 17px;
  left: 17px;
}
.showimg:active {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/navcon.vue